/**
 * PROSHOP — Catalogue : facettes WP Grid Builder transformées en dropdowns
 * (le titre de la facette = déclencheur, le contenu = popup sombre) + « Plus de filtres ».
 * Le markup WPGB d'une facette : .wpgb-facet > .wpgb-facet-title (label) + <fieldset> (contenu).
 */
(function () {
    'use strict';

    // facette actuellement ouverte (data-facet) — conservée à travers les re-render AJAX de WPGB
    var openFacetId = null;

    // Met à jour le badge « nombre de filtres actifs » d'une facette déroulante
    function updateCount(facet) {
        var title = facet.querySelector(':scope > .wpgb-facet-title');
        if (!title) {
            return;
        }
        var nb = facet.querySelectorAll('fieldset [aria-pressed="true"]').length;
        var badge = title.querySelector('.pdw-facet-count');
        if (nb > 0) {
            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'pdw-facet-count';
                title.appendChild(badge);
            }
            badge.textContent = nb;
        } else if (badge) {
            badge.remove();
        }
    }

    function setup() {
        var bar = document.querySelector('.pdw-catalog-facets');
        if (bar) {
            bar.querySelectorAll('.wpgb-facet').forEach(function (facet) {
                if (facet.parentElement !== bar) {
                    return;
                }
                var title = facet.querySelector('.wpgb-facet-title');
                // on ne prend que le titre visible (pas la légende sr-only)
                if (title && title.parentElement === facet) {
                    facet.classList.add('pdw-facet-dd');
                    title.setAttribute('role', 'button');
                    title.setAttribute('tabindex', '0');
                    updateCount(facet);
                }
            });

            // ré-ouvre la facette qui était ouverte avant le re-render WPGB (multi-sélection)
            if (openFacetId) {
                var reopen = bar.querySelector('.wpgb-facet[data-facet="' + openFacetId + '"]');
                if (reopen) {
                    reopen.classList.add('is-open');
                }
            }
        }

        // « Plus de filtres »
        var btn = document.querySelector('.pdw-catalog-more');
        var panel = document.getElementById('pdw-catalog-more-panel');
        if (btn && panel && !btn.dataset.pdwReady) {
            btn.dataset.pdwReady = '1';
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (panel.hasAttribute('hidden')) {
                    closeAll();
                    panel.removeAttribute('hidden');
                    btn.setAttribute('aria-expanded', 'true');
                } else {
                    panel.setAttribute('hidden', '');
                    btn.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }

    function closeMore() {
        var btn = document.querySelector('.pdw-catalog-more');
        var panel = document.getElementById('pdw-catalog-more-panel');
        if (panel && !panel.hasAttribute('hidden')) {
            panel.setAttribute('hidden', '');
            if (btn) {
                btn.setAttribute('aria-expanded', 'false');
            }
        }
    }

    function closeAll(except) {
        document.querySelectorAll('.pdw-facet-dd.is-open').forEach(function (f) {
            if (f !== except) {
                f.classList.remove('is-open');
            }
        });
        openFacetId = except ? except.getAttribute('data-facet') : null;
    }

    document.addEventListener('click', function (e) {
        var title = e.target.closest('.pdw-facet-dd > .wpgb-facet-title');
        if (title) {
            var facet = title.parentElement;
            var willOpen = !facet.classList.contains('is-open');
            closeAll(willOpen ? facet : null);
            closeMore();
            facet.classList.toggle('is-open', willOpen);
            openFacetId = willOpen ? facet.getAttribute('data-facet') : null;
            e.preventDefault();
            return;
        }

        // clic sur une case d'un dropdown → on garde le dropdown ouvert + on recompte
        var box = e.target.closest('.pdw-facet-dd [aria-pressed]');
        if (box) {
            var dd = box.closest('.pdw-facet-dd');
            if (dd) {
                openFacetId = dd.getAttribute('data-facet'); // reste ouvert après re-render WPGB
                window.setTimeout(function () { updateCount(dd); }, 0);
            }
            return;
        }

        // clic en dehors d'une facette / du popup → on ferme tout
        if (!e.target.closest('.pdw-facet-dd') && !e.target.closest('.pdw-catalog-more-wrap')) {
            closeAll();
            closeMore();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeAll();
            closeMore();
        }
    });

    // ré-initialisation après rafraîchissement AJAX des facettes (WP Grid Builder)
    if (window.jQuery) {
        jQuery(document.body).on('wpgb.loaded wpgb.appended wpgb.refreshed wpgb.changed', setup);
    }

    // Filet de sécurité : WPGB peuple/re-render le contenu des facettes APRÈS le load et
    // hors des événements jQuery → un MutationObserver ré-applique setup() à chaque changement
    // (masquage de la catégorie courante, badges, dropdowns). rAF debounce = pas de boucle.
    function observeFacets() {
        if (!window.MutationObserver) {
            return;
        }
        var containers = document.querySelectorAll('.pdw-catalog-filters, .pdw-catalog-facets, .pdw-catalog-active');
        if (!containers.length) {
            return;
        }
        var scheduled = false;
        var obs = new MutationObserver(function () {
            if (scheduled) {
                return;
            }
            scheduled = true;
            window.requestAnimationFrame(function () {
                scheduled = false;
                setup();
            });
        });
        containers.forEach(function (c) {
            obs.observe(c, { childList: true, subtree: true });
        });
    }

    if (document.readyState !== 'loading') {
        setup();
        observeFacets();
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            setup();
            observeFacets();
        });
    }

    // NB : l'animation d'entrée des cartes (cascade au 1er paint + en AJAX) est désormais
    // gérée 100 % en CSS (cf. _theme-product-card-proshop.scss : @keyframes pdw-card-in +
    // stagger nth-child) → aucun JS requis, et ça reste robuste même si ce bundle est en cache.
})();
